import { Role as C } from "@waitroom/models";
import { httpService as D } from "@waitroom/http-client";
let i;
const H = (E) => {
  i = E;
}, m = [
  C.GUEST,
  C.VIEWER,
  C.HOST,
  C.SESSION_INFO_VIEWER,
  C.SESSION_PRODUCER
];
var S = /* @__PURE__ */ ((E) => (E.Audio = "audio", E.Mic = "mic", E.Camera = "camera", E.Beauty = "beauty", E.SuperClarity = "superClarity", E.Denoiser = "denoiser", E.Stats = "stats", E.Background = "background", E.Quality = "quality", E.OffTheRecord = "offTheRecord", E))(S || {}), a = /* @__PURE__ */ ((E) => (E.CLS = "CLS", E.FCP = "FCP", E.FID = "FID", E.LCP = "LCP", E.TTFB = "TTFB", E))(a || {}), O = /* @__PURE__ */ ((E) => (E.WebVitals = "WEB_VITALS", E.UserVerifyOTP = "USER_VERIFY_OTP", E.MeetingUpdated = "MEETING_UPDATED", E.MeetingCreated = "MEETING_CREATED", E.HostOptedIn = "HOST_OPTED_IN", E.Logout = "LOGOUT", E.UserJoinedMeeting = "USER_JOINED_MEETING", E.MeetingAccessApproved = "MEETING_ACCESS_APPROVED", E.MeetingAccessRejected = "MEETING_ACCESS_REJECTED", E.MeetingAccessRequested = "MEETING_ACCESS_REQUESTED", E.HostCohostRequestAccepted = "HOST_COHOST_REQUEST_ACCEPTED", E.HostCohostRequestRejected = "HOST_COHOST_REQUEST_REJECTED", E.HostCohostInvited = "HOST_COHOST_INVITED", E.HostCohostRemoved = "HOST_COHOST_REMOVED", E.HostCohostStopHosting = "HOST_COHOST_STOP_HOSTING", E.MeetingInviteSent = "MEETING_INVITE_SENT", E.DomainAdded = "DOMAIN_ADDED", E.UserProfileUpdated = "USER_PROFILE_UPDATED", E.HostResumedQueue = "HOST_RESUMED_QUEUE", E.HostPausedQueue = "HOST_PAUSED_QUEUE", E.UserQueueLeft = "USER_QUEUE_LEFT", E.GuestQueueSkipped = "GUEST_QUEUE_SKIPPED", E.UserSendEmoji = "USER_SEND_EMOJI", E.UserChimeInRequested = "USER_CHIME_IN_REQUESTED", E.UserChimeInCancelled = "USER_CHIME_IN_CANCELLED", E.UserChimeInApproved = "USER_CHIME_IN_APPROVED", E.UserChimeInRejected = "USER_CHIME_IN_REJECTED", E.UserChimeInStarted = "USER_CHIME_IN_STARTED", E.MeetingStarted = "MEETING_STARTED", E.MeetingRestarted = "MEETING_RESTARTED", E.UserQueueJoined = "USER_QUEUE_JOINED", E.HostSkippedGuest = "HOST_SKIPPED_GUEST", E.HostBlockedGuest = "HOST_BLOCKED_GUEST", E.AddBots = "ADD_BOTS", E.MeetingEnded = "MEETING_ENDED", E.MeetingInviteRevoked = "MEETING_INVITE_REVOKED", E.DomainRemoved = "DOMAIN_REMOVED", E.UserChangedSetting = "USER_CHANGED_SETTING", E.UserScreenshareStarted = "USER_SCREENSHARE_STARTED", E.UserScreenshareEnded = "USER_SCREENSHARE_ENDED", E.TestCamMic = "TEST_CAM_AND_MIC", E.FeedItemCopy = "COPY_FEED_ITEM", E.FeedItemToggleContext = "TOGGLE_CONTEXT", E.FeedItemEdited = "FEED_ITEM_EDITED", E.FeedItemDeleted = "FEED_ITEM_DELETED", E.FeedItemRestored = "FEED_ITEM_RESTORED", E.FeedItemCompleted = "FEED_ITEM_COMPLETED", E.IntegrationAdded = "INTEGRATION_ADDED", E.IntegrationRemoved = "INTEGRATION_REMOVED", E.FeedItemIntegrationUsed = "FEED_ITEM_INTEGRATION_USED", E.OffTheRecord = "OFF_THE_RECORD", E.SubscriptionSurvey = "SUBSCRIPTION_SURVEY", E.SubscriptionReactivated = "SUBSCRIPTION_REACTIVATED", E.SubscriptionCancelled = "SUBSCRIPTION_CANCELLED", E.SubscriptionFreeTrialStarted = "SUBSCRIPTION_FREE_TRIAL_STARTED", E.SubscriptionFreeTrialDeclined = "SUBSCRIPTION_FREE_TRIAL_DECLINED", E.PostMeetingSurveySatisfaction = "POST_MEETING_SURVEY_SATISFACTION", E.PostMeetingSurveyFeedback = "POST_MEETING_SURVEY_FEEDBACK", E))(O || {}), d = /* @__PURE__ */ ((E) => (E.CheckoutLoaded = "CHECKOUT_LOADED", E.CheckoutClosed = "CHECKOUT_CLOSED", E.CheckoutUpdated = "CHECKOUT_UPDATED", E.CheckoutCompleted = "CHECKOUT_COMPLETED", E.CheckoutError = "CHECKOUT_ERROR", E.CheckoutFailed = "CHECKOUT_FAILED", E.CheckoutItemsUpdated = "CHECKOUT_ITEMS_UPDATED", E.CheckoutItemsRemoved = "CHECKOUT_ITEMS_REMOVED", E.CheckoutCustomerCreated = "CHECKOUT_CUSTOMER_CREATED", E.CheckoutCustomerUpdated = "CHECKOUT_CUSTOMER_UPDATED", E.CheckoutCustomerRemoved = "CHECKOUT_CUSTOMER_REMOVED", E.CheckoutPaymentSelected = "CHECKOUT_PAYMENT_SELECTED", E.CheckoutPaymentInitiated = "CHECKOUT_PAYMENT_INITIATED", E.CheckoutPaymentFailed = "CHECKOUT_PAYMENT_FAILED", E.CheckoutDiscountApplied = "CHECKOUT_DISCOUNT_APPLIED", E.CheckoutDiscountRemoved = "CHECKOUT_DISCOUNT_REMOVED", E))(d || {});
const M = 5;
var T = /* @__PURE__ */ ((E) => (E.RECORDING_WATCH_STARTED = "RECORDING_WATCH_STARTED", E.RECORDING_WATCH_CHECKPOINT = "RECORDING_WATCH_CHECKPOINT", E.RECORDING_WATCH_SEEKED = "RECORDING_WATCH_SEEKED", E.RECORDING_PAUSED = "RECORDING_PAUSED", E.RECORDING_ENDED = "RECORDING_ENDED", E.RECORDING_RESUMED = "RECORDING_RESUMED", E.RECORDING_WAITING = "RECORDING_WAITING", E.RECORDING_SHARED = "RECORDING_SHARED", E))(T || {});
const l = (E, e) => {
  if (E.session && E.session.isPubliclyVisible)
    return E;
  const { sessionTitle: _, sessionAbout: o, imageURL: s } = e;
  return {
    session: E.session ? {
      ...E.session,
      sessionTitle: _,
      about: o,
      cover: "",
      sessionCategory: void 0,
      sessionTags: void 0
    } : void 0,
    imageUrl: s
  };
}, U = async (E, e) => {
  var r;
  const _ = new URLSearchParams(E.data), o = `${i.branch.domain}?${_.toString()}`;
  if (e)
    return o;
  const s = await D.post({
    url: "https://api2.branch.io/v1/url",
    data: {
      branch_key: i.branch.key,
      ...E
    },
    timeout: 6e3,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    }
  });
  return ((r = s == null ? void 0 : s.data) == null ? void 0 : r.url) || o;
}, c = (E) => E || "https://public-rumi.s3.amazonaws.com/images/meta/rumi.png", I = (E, e) => {
  const _ = c(e);
  return {
    $desktop_url: E,
    $ios_url: E,
    $android_url: E,
    $canonical_url: E,
    $og_image_url: _,
    $twitter_image_url: _
  };
}, N = (E, e) => {
  const _ = `sessions/${E.sessionID}`, o = `${i.baseUrl}/${_}`;
  return {
    $canonical_identifier: _,
    $og_title: E.sessionTitle,
    $marketing_title: E.sessionTitle,
    "~tags": [
      ...E.sessionCategory ? [E.sessionCategory.categoryNameLowercase] : [],
      ...E.sessionTags || []
    ].filter((s) => !!s),
    $og_description: E.about,
    $twitter_title: E.sessionTitle,
    $twitter_description: E.about,
    ...I(o, e)
  };
}, A = (E, e, _) => {
  const o = `recordings/${E.sessionID}/${e}`, s = `${i.baseUrl}/${o}`;
  return {
    $canonical_identifier: o,
    $og_title: E.sessionTitle,
    $marketing_title: E.sessionTitle,
    "~tags": [
      "EPISODE",
      ...E.sessionCategory ? [E.sessionCategory.categoryNameLowercase] : [],
      ...E.sessionTags || []
    ].filter((r) => !!r),
    $og_description: E.about,
    $twitter_title: E.sessionTitle,
    $twitter_description: E.about,
    ...I(s, _)
  };
}, g = ({
  session: E,
  episodeId: e,
  imageUrl: _,
  campaignData: o,
  additionalData: s,
  longLink: r
}) => {
  let t = N(E, _);
  e && (t = A(E, e, _));
  const R = {
    ...o || {},
    data: {
      ...t,
      ...s || {}
    }
  };
  return U(R, r);
};
export {
  M as CHECKPOINT_INTERVAL,
  d as CheckoutEventType,
  O as EventType,
  T as PlayerEvent,
  m as SESSIONABLE_ROLES,
  S as Setting,
  a as WebVitalsMetric,
  i as config,
  N as createBranchLinkDataForSession,
  A as createBranchLinkDataForSessionEpisode,
  g as createBranchLinkForSession,
  l as filterSessionData,
  U as getBranchUrl,
  I as getDeeplinkUrlData,
  c as getDefaultImageUrl,
  H as initConfig
};
